import { render, staticRenderFns } from "./EmergencyManage.vue?vue&type=template&id=bdbcbe26&scoped=true&"
import script from "./EmergencyManage.vue?vue&type=script&lang=js&"
export * from "./EmergencyManage.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyManage.vue?vue&type=style&index=0&id=bdbcbe26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbcbe26",
  null
  
)

export default component.exports